export default [
    { //资讯列表
        path: '/messageManagement',
        name:'messageManagement',
        meta: { title: '资讯列表'},
        component: () => import('../../views/messageManagement/index.vue')
    },
    { //资讯明细
        path: '/messageManagement/detail',
        name:'messageManagementDetail',
        meta: { title: '资讯明细'},
        component: () => import('../../views/messageManagement/detail.vue')
    },
    { //发布资讯
        path: '/messageManagement/add',
        name:'messageManagementAdd',
        meta: { title: '发布资讯'},
        component: () => import('../../views/messageManagement/add.vue')
    },
    { //编辑资讯
      path: '/messageManagement/edit',
      name:'messageManagementEdit',
      meta: { title: '编辑资讯'},
      component: () => import('../../views/messageManagement/edit.vue')
  },
]